/** Copy classification only. The server still chooses/charges the recorded
 * default; this never substitutes a card, writes it or changes a start gate.
 * CARD_EXPIRED is the pre-session page's own block (startCardExpiry.ts), raised
 * before Start so an expired card never reaches the server or the charger. */
export function isExpiredStartCard(error: { code: string; data?: { stripeErrorCode?: string | null; stripeDeclineCode?: string | null } }): boolean {
  if (error.code === 'CARD_EXPIRED') return true;
  return error.code === 'PRE_AUTH_FAILED' && (error.data?.stripeErrorCode === 'expired_card' || error.data?.stripeDeclineCode === 'expired_card');
}

/** A saved card from the old app that Stripe will not reuse (the SPECK case, 29 Oct 2026): driver-start answers
 * PRE_AUTH_FAILED with detail CARD_NEEDS_READD, and the page asks the driver to add the card again. Copy only. */
export function isReaddStartCard(error: { code: string; detail?: string }): boolean {
  return error.code === 'PRE_AUTH_FAILED' && error.detail === 'CARD_NEEDS_READD';
}
